import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';

import { isDefined } from '@hsp/utilities';

import { useAppSelector } from 'hooks/store';
import { saveQueryKeys } from 'pages/audience/shared/save/query-keys';
import { userService } from 'services';
import { selectUserId } from 'store/selectors';
import { IAudience } from 'types/api/audience';
import { IResult } from 'types/api/common';

export const useFetchAudiences = () => {
  const userId = useAppSelector(selectUserId);

  return useQuery({
    enabled: isDefined(userId),
    queryFn: async () => await userService.getAudiences({ page: -1, sort: 'name asc', userId }),
    queryKey: saveQueryKeys.audiences(userId),
    select: useCallback((data: IResult<IAudience[]> | undefined) => data?.dataContainer ?? [], []),
  });
};
